// extracted by mini-css-extract-plugin
export default {"isKeyboardDragging":"SortableListContainer-module__isKeyboardDragging--qC_89","container":"SortableListContainer-module__container--QrDvK"};